const snackbarConfig = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  closeButton: false,
};

export { snackbarConfig };
